import React, { useRef, useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { LayoutDashboard } from '../layouts/layout-dashboard';
import { useAxios } from '../hooks/useAxios';

const EmotionComponent = () => {
  const { data, error, loading, fetchNow } = useAxios();
  const textInput = useRef('');
  const [responseData, setResponseData] = useState();

  const getData = () => {
    if (textInput.current.value !== '') {
      fetchNow(`/api/api/text_processing_json/`, 'POST', { text: textInput.current.value }, null);
    }
  };

  useEffect(() => {
    if (data) {
      setResponseData(data);
    }
  }, [data, loading]);

  if (error) {
    console.log('error', error);
    return null;
  }

  return (
    <>
      <Container fluid>
        <Row>
          <Col lg={12} className="p-5">
            <div className="wrapper">
              <LayoutDashboard>
                <Row>
                  <Col>
                    <textarea style={{ width: '100%' }} ref={textInput} type="text" />
                  </Col>
                </Row>
                <Row>
                  <Col>{loading ? 'Loading...' : <Button onClick={getData}>Get Emotion</Button>}</Col>
                </Row>
                <Row>
                  <Col>
                    <ul>
                      {responseData?.data.map((result, key) => (
                        <li key={key}>
                          <strong>Emotion:</strong> <br />
                          {result?.emotion} <br />
                          <strong>Text:</strong> <br />
                          {result?.text} <br />
                          <br />
                        </li>
                      ))}
                    </ul>
                  </Col>
                </Row>
              </LayoutDashboard>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export { EmotionComponent };
